import React from 'react';

import DataInfo from '../../shared/displayComponents/dataInfo/dataInfo.component';

const ProcessingUpload = () => (
  <DataInfo textToRender="We are processing your file" variant="progress" showSpinner />
);

export default ProcessingUpload;
